import React from 'react';

import NewAccountLoader from './NewAccountLoader';
import NewAccountForm from './NewAccountForm';
import Stack from '../../Shared/UI/Stack/components/Stack';

import styles from './NewAccount.module.scss';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';

const NewAccount = () => {
  return (
    <>
      <NewAccountLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text="Create Account" />
          <NewAccountForm />
        </Stack>
      </div>
    </>
  );
};

export default NewAccount;
